import React, { useState, useEffect, useRef } from "react";
import { Input } from "antd";
import "./style.scss";
import { HeaderSearchIcon } from "assets/icons";

const words = ["AEC ID", "Profession", "Location", "Qualification"];

const SearchInput = ({ onSearchChange, onSearch, open }) => {
  const searchInputRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [input, setInput] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  }, [open]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInput(value);

    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  // 🔹 When Enter key pressed
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(input);
    }
  };

  // 🔹 When clicking search icon
  const handleIconClick = () => {
    if (onSearch) {
      onSearch(input);
    }
  };

  return (
    <div className="search-input">
      <Input
        ref={searchInputRef}
        value={input}
        className="custom-search-input"
        placeholder=""
        suffix={
          <span onClick={handleIconClick} style={{ cursor: "pointer" }}>
            <HeaderSearchIcon />
          </span>
        }
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      {!input && (
        <div className="animated-placeholder">
          <span className="placeholder">I'm looking for </span>
          <div className="text-slider">
            <div className="slider-content">
              <div className="text-wrapper">
                <div
                  className="text-list"
                  style={{
                    transform: `translateY(-${currentIndex * 100}%)`,
                    transition: "transform 0.5s ease-in-out",
                  }}
                >
                  {words.map((text, index) => (
                    <div key={index} className="text-item">
                      <h6>{text}</h6>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchInput;
